export default "__VITE_ASSET__Dqjw0TGs__"